import { CloseRoute } from './close-route';

export class RouterPathInfo {
    history: string[];
    closeRoute: CloseRoute;
}
